export const OperationStatus = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
};
